import React, { useEffect, useState } from 'react';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { Member, Space } from '../../../app/entities';
import {
  previewAddMemberUpdates,
  PreviewAddMemberUpdatesResponse,
} from '../../billing/store/billing.slice';
import { PaymentPreview } from './payment-preview';
import { Alert } from '../../../components/alert/Alert';
import { HasServerResponse } from '../../../components/PanelContainer';
import { toastPool } from '../../toasts/models/toast-pool';
import { Toast } from '../../toasts/models/toast';

import styles from './promote-member.modal.module.scss';
interface PromoteMemberModalProps {
  member: Member;
  space: Space;
  onCancel: () => void;
}

export const PromoteMemberModal: React.FC<PromoteMemberModalProps> = ({
  member,
  space,
  onCancel,
}) => {
  const [isFetchingPrice, setIsFetchingPrice] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState<PreviewAddMemberUpdatesResponse | null>(
    null,
  );
  const [serverError, setServerError] = useState('');
  const [isPromoting, setIsPromoting] = useState(false);

  const handlePromote = async () => {
    if (isPromoting) return;

    setIsPromoting(true);
    try {
      await member.promote();
      toastPool.insert(new Toast('Member successfully promoted', 'success'));
      onCancel();
      setIsPromoting(false);
    } catch (e) {
      setIsPromoting(false);
    }
  };

  useEffect(() => {
    if (!space?.hasSubscription()) return;

    setIsFetchingPrice(true);
    previewAddMemberUpdates(space._id, 1)
      .then((response) => {
        setPaymentDetails(response || null);
        setIsFetchingPrice(false);
      })
      .catch((e) => {
        setServerError(`${e}`);
        setIsFetchingPrice(false);
      });
  }, [space, space?.subscription?.subscriptionId]);

  return (
    <Dialog
      title={`Promote ${member.fullName}`}
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} disabled={isPromoting} />,
        <ElevatedButton
          key="validate"
          onClick={handlePromote}
          text="Promote to creator"
          isLoading={isPromoting}
          autoFocus
        />,
      ]}
    >
      <div className={styles['container']}>
        {serverError && (
          <HasServerResponse className={styles['server-error-message']}>
            <Alert text={serverError} />
          </HasServerResponse>
        )}

        <p>
          By promoting a guest to a creator, they will gain access to your whole space and you will
          be charged for the additional creator.
        </p>
      </div>

      {space?.hasSubscription() && (
        <PaymentPreview isLoading={isFetchingPrice} paymentDetails={paymentDetails} />
      )}
    </Dialog>
  );
};
